module.exports = __webpack_public_path__ + "img/go-reco.65734453.svg";